module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "book"
  }, [(_vm.type == 1) ? _c('div', {
    staticClass: "images"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'publishHomeWork',
        query: {
          bookId: _vm.booksData.productId,
          bookName: _vm.booksData.productName,
          serviceId: _vm.booksData.serviceId,
          packageId: _vm.booksData.packageId,
          subject: _vm.booksData.subject,
          isFirst: 1
        }
      }
    }
  }, [(_vm.booksData.cover) ? _c('img', {
    attrs: {
      "src": _vm.booksData.cover,
      "alt": ""
    }
  }) : (!_vm.booksData.cover) ? _c('img', {
    attrs: {
      "src": require("../../assets/img/default.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('i', {
    class: {
      isTop: _vm.booksData.istop == 1
    },
    on: {
      "click": _vm.setTop
    }
  })], 1) : _c('div', {
    staticClass: "images"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: 'publishBooks',
        query: {
          paper: _vm.booksData,
          type: 2
        }
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/defaultPaper.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "paper_title",
    attrs: {
      "title": _vm.booksData.examinationTitle
    }
  }, [_vm._v(_vm._s(_vm.booksData.examinationTitle))])]), _vm._v(" "), _c('span', {
    staticClass: "view_btn",
    on: {
      "click": _vm.view
    }
  }, [_vm._v("预览")])], 1), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "bookMsg"
  }, [_c('h4', {
    attrs: {
      "title": _vm.booksData.bookName
    }
  }, [_vm._v(_vm._s(_vm.booksData.productName))]), _vm._v(" "), _c('p', {
    attrs: {
      "title": _vm.booksData.serviceName
    }
  }, [_vm._v(_vm._s(_vm.booksData.serviceName))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1598f7fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/book/book.vue
// module id = 1158
// module chunks = 1